import React, { Component, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import LoginService from "../../services/LoginService";
import * as images from "../../constants/Images";
import "./Login.css";
import Loadspinner from "../../common/Loadspinner";
// import Swal from "sweetalert2";
// import Encrypt from "../../services/Encryption";
// import Encrypt2 from "../../services/Encryption2";
// //import { socket } from "../../common/Socket";
// import Decrypt from "../../services/Decryption";
// import { analytics } from "../../firebase";
// import { logEvent } from "firebase/analytics";
import { APICall } from "../../helpers/API/APICalls";
//import { checkUserDivisionAndRole } from "../../helpers/API/APIEndPoints";
import {
  checkUserDivision,
  checkUserDivisionAndRole,
  getConfigValuesByIds,
  getRedirectionUrl,
} from "../../helpers/API/APIEndPoints";
//import { invokeApi } from "../../services";
import { addUserData, configSet } from "../../redux/actions";
//import store from "../../redux/store";
import axios from "axios";
import { decryptV2, encryptV2 } from "../../helpers/Cryptography/CryptoV2";
import { authenticate, login, whoami } from "../../constants/ApiEndpoints";
import { useDispatch } from "react-redux";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";
import Loader from "react-loader-spinner";
/* import Swal from "sweetalert2"; */
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { addContextToLocalStorage } from "../../helpers/Context/Context";
import {
  getFromEncLocalStorage,
  storeInEncLocalStorage,
} from "../../helpers/Utils/Utils";
import Encrypt from "../../services/Encryption";
import { decrypt } from "../../helpers/Cryptography/Crypto";

// import io from "socket.io-client";
// import { base_url } from "../../constants/ApiEndpoints";

//import OneSignal from "react-onesignal";

//import { loginData } from "./data";

//import { socket } from "../../common/Socket";

let isSSOSuccessfull = true;

const LoginV2 = (props) => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedin, setIsLoggedin] = useState(false);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFirst, setIsFirst] = useState(false);
  const [isInterestEmpty, setIsInterestEmpty] = useState(false);
  const [sso, setSso] = useState(false);
  const [showRegistrationRedirection, setShowRegistrationRedirection] =
    useState(false);
  const [onAlreadyLoggedIn, setOnAlreadyLoggedIn] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const COMMON_MASTER_FRONTEND_URL = import.meta.env
    ?.VITE_COMMON_MASTER_FRONTEND_URL;

  console.log(
    `COMMON_MASTER_FRONTEND_URL`,
    `${COMMON_MASTER_FRONTEND_URL}/registration`,
  );

  const [registrationURL, setRegistrationURL] = useState(
    `${COMMON_MASTER_FRONTEND_URL}/registration`,
  );
  const [formErrors, setFormErrors] = useState({});
  const [showLoader1, setShowLoader] = useState(true);

  const loginTimeoutInms = 2 * 60 * 1000; //2 min
  let firstDecryptForBranding;

  let tempToken = null;
  const token = getFromEncLocalStorage("token") || null;

  const handleChange = (e) => {
    switch (e.target.name) {
      case "username":
        setUsername(e.target.value);
        break;
      case "password":
        setPassword(e.target.value);
        break;
    }
  };

  const handleSubmit = async (e) => {
    //const str = "usr=25008117===pwd=Shami@1304===dvk=c82c260e09577fda";
    //const str = "usr=207624===pwd=Happy&1703";
    //const str = "usr=214333===pwd=m&mprd@69===dvk=c82c260e09577fda";

    // const str = "usr=25007698===pwd=Time@000===dvk=c82c260e09577fda";
    // const str = "RACHTE-CONT@mahindra.com===mahindra@4";
    // const str = "JADHPU-CONT===Say&Raj@0824";
    // const str = "23066139===Rise@345";

    ssoLogin();

    return;

    // let { username, password } = this.state;
    // const str = `${username}===${password}`;
    // e.preventDefault();
    // this.setState({ isLoading: true });
    // const token = Encrypt(JSON.stringify({ data: str, encryptionType: true }));
    // const data = await LoginService.kmslogin(token, username);
    // // const data = JSON.parse(response.data);
    // // console.log('login response---',await data.json())
    // const response = await data.json();

    // if (response && response.responseStatus === 1) {
    //   const user = JSON.parse(Decrypt(response.data));
    //   storeInEncLocalStorage("userId", user.userId);

    //   let requestParams1 = {
    //     userEmail: user.empEmail,
    //   };

    //   let res = await APICall(checkUserDivisionAndRole, requestParams1, "POST");

    //   if (res.message === "Ok") {
    //     storeInEncLocalStorage("ggwp", Encrypt(String(res.data[0].Valid)));

    //     const shouldRedirect = res.data.filter((d) => d.DivisionName === "FD").length == 0;
    //     if (shouldRedirect) {
    //       //if (res.data.DivisionName === "AD") {
    //       // redirect to kms-frontend
    //       let reqPar = {
    //         caseForRedirection: "kms-frontendPortalURL",
    //       };
    //       let res1 = await APICall(getRedirectionUrl, reqPar, "POST");
    //       if (res1.message === "Ok") {
    //         window.open(res1.data[0].Value, "_blank");
    //       }
    //     } else {
    //       //redirect to mkisan
    //       storeInEncLocalStorage("token", user.token);
    //       // storeInEncLocalStorage("employeenumber", Encrypt(user.employeenumber));
    //       storeInEncLocalStorage("employeenumber", user.employeenumber);
    //       storeInEncLocalStorage("userId", user.userId);
    //       //storeInEncLocalStorage("profile_pic", user.profile_pic);
    //       storeInEncLocalStorage("firstname", user.firstname);
    //       storeInEncLocalStorage("lastname", user.lastname);
    //       storeInEncLocalStorage("nameofposition", user.nameofposition);
    //       storeInEncLocalStorage("empDeptName", user.empDeptName);
    //       storeInEncLocalStorage("accountId", user.mediaServeInfo.account_id);
    //       storeInEncLocalStorage("subKey", user.mediaServeInfo.subscription_key);
    //       storeInEncLocalStorage("location", user.mediaServeInfo.location);

    //       this.setState({ user });
    //       const singleEncryption = Encrypt2(str);
    //       //const doubleEncryption = Encrypt2(singleEncryption);
    //       storeInEncLocalStorage("CK", singleEncryption);

    //       storeInEncLocalStorage("token", user.token);
    //       // storeInEncLocalStorage("employeenumber", Encrypt(user.employeenumber));
    //       storeInEncLocalStorage("employeenumber", user.employeenumber);
    //       //storeInEncLocalStorage("profile_pic", user.profile_pic);
    //       storeInEncLocalStorage("firstname", user.firstname);
    //       storeInEncLocalStorage("lastname", user.lastname);
    //       storeInEncLocalStorage("nameofposition", user.nameofposition);
    //       storeInEncLocalStorage("empDeptName", user.empDeptName);
    //       storeInEncLocalStorage("accountId", user.mediaServeInfo.account_id);
    //       storeInEncLocalStorage("subKey", user.mediaServeInfo.subscription_key);
    //       storeInEncLocalStorage("location", user.mediaServeInfo.location);

    //       try {
    //         const configValuesResp = await fetch(getConfigValuesByIds, {
    //           method: "POST",
    //           body: JSON.stringify({
    //             data: Encrypt(JSON.stringify({ ids: [5, 11, 12, 13, 17, 18, 19] })),
    //           }),
    //           headers: {
    //             "Content-Type": "application/json",
    //           },
    //         });
    //         if (configValuesResp.status === 200) {
    //           const configValues = await configValuesResp.json();
    //           if (configValues && configValues?.message === "Ok") {
    //             let configValuesData = configValues?.data;
    //             const configValuesDataArr = Object.entries(configValuesData);
    //             for (let index = 0; index < configValuesDataArr.length; index++) {
    //               const cvd = configValuesDataArr[index];
    //               storeInEncLocalStorage(cvd[0], cvd[1]);
    //             }
    //             store.dispatch(configSet());
    //           }
    //         }
    //       } catch (err) {
    //         console.error(err);
    //       }

    //       this.setState({ isFirst: user.isFirstLogin });
    //       this.setState({ isLoggedin: true });
    //     }
    //   }
    //   // window.socketObj = socket();
    //   // // console.log(window.socketObj);
    //   // window.socketObj.on("RESPONSE", (response) => {
    //   //   response;
    //   // });
    //   // window.socketObj.emit("online");
    // } else {
    //   Swal.fire({
    //     text: response?.message || "Username or password is incorrect",
    //     toast: true,
    //   });
    // }

    // logEvent(analytics(), "login", { method: "withcredentials" });
    // this.setState({ isLoading: false });

    // // if (
    // //   response.auth_status == "true" &&
    // //   response.access_token != null &&
    // //   response.access_token != "" &&
    // //   response.access_token != undefined
    // // ) {
    // //   const res = JSON.stringify(response);
    // //   this.sendData(res);
    // // } else {
    // //   this.setState({ isLoading: false });
    // //   Swal.fire({
    // //     text: "Username or password is incorrect",
    // //     toast: true,
    // //   });
    // // }
    // // if (!response) {
    // //   this.setState({ isLoading: false });
    // //   Swal.fire({
    // //     text: "Username or password is incorrect",
    // //     toast: true,
    // //   });
    // // }
  };

  const sendData = async (res) => {
    let resp = JSON.parse(res);
    // const playerId = await OneSignal.getPlayerId();
    // resp.player_id = playerId;
    resp.player_id = "51065bc9-68be-475e-9dd0-1cd042f7da36";

    let reqRes = JSON.stringify(resp);
    const data = await LoginService.kmslogin(reqRes);

    if (data) {
      this.setState({ data });
      storeInEncLocalStorage("token", data.token);
      storeInEncLocalStorage("employeenumber", data.employeenumber);
      //storeInEncLocalStorage("profile_pic", data.profile_pic);
      storeInEncLocalStorage("firstname", data.firstname);
      storeInEncLocalStorage("lastname", data.lastname);
      storeInEncLocalStorage("nameofposition", data.nameofposition);
      storeInEncLocalStorage("empDeptName", data.empDeptName);
      storeInEncLocalStorage("accountId", data.mediaServeInfo.account_id);
      storeInEncLocalStorage("subKey", data.mediaServeInfo.subscription_key);
      storeInEncLocalStorage("location", data.mediaServeInfo.location);

      setIsFirst(data.isFirstLogin);
      setIsLoggedin(true);
      // window.socketObj = socket();
      // // console.log(window.socketObj);
      // window.socketObj.on("RESPONSE", (data) => {
      //   data;
      // });
      // window.socketObj.emit("online");
    }

    //setIsLoading(true);
  };

  const showLoader = () => {};

  const hideLoader = () => {};

  const callConfigDataFunction = async () => {
    try {
      const configValuesResp = await fetch(getConfigValuesByIds, {
        method: "POST",
        body: JSON.stringify({
          data: Encrypt(JSON.stringify({ ids: [21, 22] })),
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (configValuesResp.status === 200) {
        const configValues = await configValuesResp.json();
        if (configValues && configValues?.message === "Ok") {
          let configValuesData = configValues?.data;

          let decryptedConfigValues = decryptV2(configValuesData);
          if (typeof decryptedConfigValues === "string") {
            decryptedConfigValues = JSON.parse(decryptedConfigValues);
          }
          const configValuesDataArr = Object.entries(decryptedConfigValues);
          for (let index = 0; index < configValuesDataArr.length; index++) {
            const cvd = configValuesDataArr[index];
            storeInEncLocalStorage(cvd[0], cvd[1]);
          }
          // store.dispatch(configSet());
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const ssoLogin = async () => {
    axios({
      method: "GET",
      url: `${whoami}`,
      withCredentials: true,
    })
      .then(async (response) => {
        let decryptedData = decryptV2(response.data.user);
        decryptedData = JSON.parse(decryptedData);
        console.log("decryptedData: ", decryptedData);
        if (
          decryptedData.nameID &&
          decryptedData.nameID !== undefined &&
          decryptedData.nameID !== null
        ) {
          isSSOSuccessfull = true;
          setUsername(decryptedData.nameID);
          hideLoader();
          onSubmit("login", decryptedData.nameID);
        } else {
          isSSOSuccessfull = false;
          setShowLogin(true);
          setShowRegistrationRedirection(false);
          setFormErrors({
            ...formErrors,
            ["password_isEmpty"]: response,
          });
          hideLoader();
        }
      })
      .catch((error) => {
        isSSOSuccessfull = false;
        setShowLogin(true);
        setShowRegistrationRedirection(false);
        // setFormErrors({
        //   ...formErrors,
        //   ["password_isEmpty"]: error.response.data.message,
        // });
        hideLoader();
        onSubmit("login");
      });

    // onSubmit("login", "Gtotest1@mahindra.com");
  };

  const RedirectToLogin = () => {
    setTimeout(() => {
      window.location.replace(authenticate);
      // window.location.replace("http://localhost:3000/");
    }, 5500);
  };

  const onSubmit = async (e, userName = "") => {
    console.log("onSubmit userName: ", userName);
    console.log("state userName: ", username);
    let lgFromDevices = false;
    if (e === "logout") {
      setOnAlreadyLoggedIn(false);
      lgFromDevices = true;
    }
    let x;
    let isEmpty;
    let str;
    let params = new URLSearchParams(location.search);
    let ckToken = params.get("CK");
    let userBrandingFromParams = params.get("SC");
    showLoader();

    if (ckToken === null) {
      // await checkValidations();
      // isEmpty = await Object.values(formErrorObj).every(
      //   (x) => x === null || x === "" || x === undefined
      // );
      str = `${username}===${password}`;
    } else {
      isEmpty = true;

      // ckToken =
      //   "bnvG89tgqs7xyFC2PcXN+llowu52f9SDKK+cbP2sMy6oaspq59e+UeXpVBXWIj9H";
      ckToken = ckToken.replaceAll(" ", "+");

      const firstDecrypt = decryptV2(ckToken);

      // firstDecryptForBranding = await Decrypt(userBrandingFromParams);
      firstDecryptForBranding = userBrandingFromParams;
      x = firstDecrypt.split("===");
      setUsername(x[0]);
      setPassword(x[1]);

      setSso(true);
      str = `${x[0]}===${x[1]}`;

      //// change this when pushing
      // x[0] = "GTOTEST2@mahindra.com";
      // str = `GTOTEST2@mahindra.com===Webtest@457`;
    }
    // if (isEmpty) {
    // const str = `${username}===${password}`;
    const token = encryptV2(
      JSON.stringify({ data: str, encryptionType: true }),
    );
    const reqBody = {
      token: token,
      username: userName || username,
      lgFromDevices: lgFromDevices,
      isFromWeb: true,
    };

    if (isSSOSuccessfull) {
      const response = await APICall(login, {
        data: reqBody,
      });

      console.log("Login response: ", response);

      if (
        response &&
        (response?.message == "Ok" ||
          response?.message?.includes(
            "User successfully registered, and successfully logged in",
          ) ||
          response?.message?.includes("You have successfully logged in")) &&
        response.responseStatus == 1
      ) {
        //const data = JSON.parse(decryptV2(response?.data));
        const data = response?.data;
        console.log("Login data: ", data);

        // let requestParams1 = {
        //   userEmail: data?.emailLdap,
        // };
        let requestParams1 = {
          userId: data.userId,
          userIdForSession: data.userId,
          userLoggedInAsPermission: data.UserRole.value,
        };

        let res = await APICall(
          checkUserDivisionAndRole,
          requestParams1,
          "POST",
        );

        if (res.message === "Ok") {
          storeInEncLocalStorage("ggwp", encryptV2(String(res.data[0].Valid)));

          // const shouldRedirect =
          //   res.data.filter((d) => d.DivisionName === "FD").length == 0;
          // if (shouldRedirect) {
          //   //if (res.data.DivisionName === "AD") {
          //   // redirect to kms-frontend
          //   let reqPar = {
          //     caseForRedirection: "kms-frontendPortalURL",
          //   };
          //   let res1 = await APICall(getRedirectionUrl, reqPar, "POST");
          //   if (res1.message === "Ok") {
          //     window.open(res1.data[0].Value, "_blank");
          //   }
          // } else {
          //this.setState({ data });
          storeInEncLocalStorage("token", data.token || "");
          storeInEncLocalStorage("employeenumber", data.employeenumber);
          //storeInEncLocalStorage("profile_pic", data.profile_pic);
          storeInEncLocalStorage("firstname", data.firstname);
          storeInEncLocalStorage("lastname", data.lastname);
          storeInEncLocalStorage("nameofposition", data.nameofposition);
          storeInEncLocalStorage("empDeptName", data.empDeptName);
          storeInEncLocalStorage("accountId", data.mediaServeInfo.account_id);
          storeInEncLocalStorage(
            "subKey",
            data.mediaServeInfo.subscription_key,
          );
          storeInEncLocalStorage("location", data.mediaServeInfo.location);
          //storeInEncLocalStorage("ggwp", encryptV2(String(res.data[0].Valid)));
          storeInEncLocalStorage("userId", data.userId);
          storeInEncLocalStorage("emailId", data.emailLdap);
          storeInEncLocalStorage("userRole", data.UserRole.value);

          let loggedInAsRoleObj = {
            label: data.UserRole.label,
            value: data.UserRole.value,
          };

          let contextObject = {
            UserId: data.userId,
            Username: `${data.firstname} ${data.lastname}`,
            Roles: data.UserRole,
            Permissions: data.UserPermissions,
            loggedInAs: loggedInAsRoleObj,
          };
          console.log(
            "🚀 ~ file: LoginV2.jsx:501 ~ contextObject:",
            contextObject,
          );
          addContextToLocalStorage(contextObject);

          setIsFirst(data.isFirstLogin);
          setIsLoggedin(true);
          setShowLogin(false);
          // window.socketObj = socket();
          // // console.log(window.socketObj);
          // window.socketObj.on("RESPONSE", (data) => {
          //   data;
          // });
          // window.socketObj.emit("online");
          //}
        }
      } else if (
        response.message === "Invalid User, Please contact administrator" ||
        response.message === "User not Registered"
      ) {
        setShowRegistrationRedirection(true);
        setShowLogin(true);
      } else if (response.message === "Already Logged In") {
        setShowLogin(true);
        setShowRegistrationRedirection(false);

        setOnAlreadyLoggedIn(true);
      } else {
        /*    Swal.fire({
          text: "Username or password is incorrect",
          toast: true,
        }); */
        toast("Username or password is incorrect");
        setShowRegistrationRedirection(false);
        setShowLogin(true);
      }

      // setIsLoading(false);
      setShowLoader(false);

      // #region code from sfquery
      // if (response.message === "Ok") {
      //   // Create context

      //   if (!firstDecryptForBranding) {
      //     const userRedirectedData = await APICall(checkUserDivision, {
      //       UserId: response.data.UserId,
      //     });

      //     firstDecryptForBranding =
      //       userRedirectedData.data === "FD" ||
      //       userRedirectedData.data === "FD-PD" ||
      //       userRedirectedData.data === "FD-Manufacturing" ||
      //       userRedirectedData.data === "Swaraj" ||
      //       userRedirectedData.data === "Mitshubishi Agricultural Machinery" ||
      //       userRedirectedData.data === "Farm Machinery"
      //         ? "mk"
      //         : "mv";
      //   }

      //   let loggedInAsRoleObj = {
      //     label: response.data.UserRole[0].label,
      //     value: response.data.UserRole[0].value,
      //   };
      //   let contextObject = {
      //     UserId: response.data.UserId,
      //     Username: response.data.Username,
      //     EmailId: response.data.EmailId,
      //     Roles: response.data.UserRole,
      //     Permissions: response.data.UserPermissions,
      //     loggedInAs: loggedInAsRoleObj,
      //     userBranding: firstDecryptForBranding,
      //   };
      //   //  await addContextToCookie(TestContext);
      //   // ;
      //   // await addContextToLocalStorage(contextObject);

      //   // add user in redux
      //   dispatch(addUserData(contextObject));

      //   ///if (contextObject.Roles[0].value == RolesList[1].value) {
      //   window.location.replace("/home");
      //   //} else {
      //   //navigate("/ApprovalDashboard");
      //   //}
      // } else if (response.message === "Invalid User, Please contact administrator" || response.message === "User not Registered") {
      //   hideLoader();
      //   setShowRegistrationRedirection(true);
      //   setShowLogin(true);
      //   // await setRegistrationURL(response.data[0][0].ConfigValue);
      //   // setFormErrors({
      //   //  ...formErrors,
      //   //   ["password_isEmpty"]: "Invalid User, Please contact administrator",
      //   // };
      // } else if (response.message === "Already Logged In") {
      //   hideLoader();
      //   setShowLogin(true);
      //   setShowRegistrationRedirection(false);

      //   setOnAlreadyLoggedIn(true);
      // } else {
      //   hideLoader();
      //   setShowLogin(true);
      //   setShowRegistrationRedirection(false);
      //   setFormErrors({
      //     ...formErrors,
      //     ["password_isEmpty"]: response.message,
      //   });
      // }
      // #endregion
    } else {
      RedirectToLogin();
    }
    hideLoader();
  };

  // useEffect(() => {
  //   // let i = 5;
  //   // let interval = setInterval(() => {
  //   //   console.log(`Redirecting in ${i--}`);
  //   // }, 5000);
  //   // let timer = setTimeout(() => {
  //   //   ssoLogin();
  //   // }, 5500);
  //   // return () => {
  //   //   clearInterval(interval);
  //   //   clearTimeout(timer);
  //   // };
  // }, []);

  const isTokenExists = getFromEncLocalStorage("token") || null;

  useEffect(() => {
    callConfigDataFunction();
    if (!isTokenExists) {
      ssoLogin();
    }
    let timer = setTimeout(() => {
      setShowLoader(false);
    }, loginTimeoutInms);

    return () => clearTimeout(timer);
  }, []);

  if (isTokenExists) {
    return <Redirect to={"/home"} />;
  }

  if (isLoggedin) {
    let lastPage = "/home";

    if (isFirst) {
      lastPage = "/profile";
    }

    return <Redirect to={lastPage} />;
  }

  return (
    <>
      {showLogin ? (
        <div className="login-bg">
          <Loadspinner
            filename="LoginV2.jsx"
            isLoading={isLoading}
            isMiddle="false"
          />
          <img src={images.mahindralogobeamwhite} alt="mahindra logo" />
          <div>
            <img
              src={images.mkisanlogo}
              alt="mkisan logo"
              className="mk-logo"
            />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ color: "white", fontSize: "0.9rem" }}>
                Mahindra Knowledge Intelligent Search Assistance Network
              </div>
            </div>

            <div className="login-patch ">
              <h5 style={{ marginBottom: "3vh" }}> USER LOGIN</h5>
              {/* <form onSubmit={handleSubmit}> */}
              {/* 
            <div className="input-group has-validation">
              <input
                type="text"
                value={username}
                name="username"
                className="form-control input-field"
                placeholder="Username"
                onChange={handleChange}
                required
                autoComplete="off"
              />
            </div>
            <div className="input-group has-validation">
              <input
                type="password"
                className="form-control input-field"
                placeholder="Password"
                onChange={handleChange}
                required
                name="password"
                autoComplete="off"
                value={password}
              />
            </div>
            */}
              {/* <Link to="/" className="forgot-password">
                Forgot Password?
              </Link> */}
              {/* <button id="footer" type="submit">
              <h5>LOGIN</h5>
            </button> */}
              {showRegistrationRedirection && (
                <>
                  <p style={{ color: "red" }}>
                    User is not registered, please register {"   "}
                    <a href={registrationURL} target="_blank" rel="noreferrer">
                      here.
                    </a>
                  </p>
                </>
              )}
              <div className="loader-container">
                {showLoader1 ? (
                  <Loader
                    type="Puff"
                    color="var(--theme-red)"
                    height={80}
                    width={80}
                  />
                ) : (
                  <button
                    type="button"
                    className="btn txt-white login-btn"
                    data-toggle="modal"
                    data-target="#login-modal-popup"
                    onClick={() => RedirectToLogin()}
                  >
                    Login with SSO
                  </button>
                )}
              </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      ) : null}

      <Modal
        show={onAlreadyLoggedIn}
        onHide={() => setOnAlreadyLoggedIn(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <div
          style={{
            background: "var(--customMain)",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "white",
          }}
        >
          <div className="col-lg-12">Logout</div>
        </div>

        <Modal.Body>
          <h5>
            You are already logged in into another device. Do you want to log
            out from other devices?
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-submit"
            style={{ marginLeft: 5 }}
            onClick={() => onSubmit("logout")}
          >
            Log out
          </button>
          <button
            className="btn btn-close"
            style={{ marginLeft: 5 }}
            onClick={() => setOnAlreadyLoggedIn(false)}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoginV2;
